import React, { useState } from 'react'
import { Button } from 'react-bootstrap'

export const CostValueAndSaveButton = (props) => {
    const [costPrice, setCostPrice] = useState(props.costPrice)
    const [disabled, setDisabled] = useState(false)
    

    const onClickSaveButton = (e) => {
        setDisabled(true)
        props.onClickSaveButton(e)
    }

    return <>
        <td><input disabled ={props.disableButtons} value={costPrice} onChange={(e) => { setCostPrice(e.target.value) }}></input></td>
        <td><Button  disabled={disabled} onClick={() => { onClickSaveButton([props.sku, costPrice]) }}>Save</Button>{props.response === (props.sku) ? 'Saved!' : ''}</td>
    </>
}